export default __webpack_public_path__ + "static/media/extraSettings.9e7780ff.svg";